// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdrCalendarWrapper {
  background: rgba(0, 0, 0, 0.02);
}
.rdrMonthAndYearPickers {
  display: none;
}
.rdrMonthName {
  text-align: center;
  font-size: 14px;
}

.rdrDay {
  background: rgba(0, 0, 0, 0.15);
}

.rdrDayNumber span {
  color: rgba(255, 255, 255, 0.85);
}

.rdrDayToday > span {
  background-color: #c65210;
  border-radius: 10px;
  padding: 2px;
  width: 18px;
  height: 18px;
  margin: auto;
}

.rdrDayToday .rdrDayNumber span:after {
  display: none;
}

.rdrCalendarWrapper {
  height: 100%;
}

.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(1):before {
  display: none !important;
}

.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(1) {
  width: 46px;
  height: 29px;
  margin-left: 12px;
  background-color: rgba(204, 204, 220, 0.16) !important;
  font-size: 14px !important;
  font-weight: normal !important;
  border-radius: 2px !important;
  border: none !important;
  color: #aaaaaa !important;
}

.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(1) > i {
  border-right-color: rgb(170, 170, 170); /* Color the Arrow */
}

.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(1):hover {
  background-color: rgba(204, 204, 220, 0.36) !important;
  cursor: pointer;
}

/* the second child is a hidden span */

.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(3):before {
  display: none !important;
}

.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(3) {
  width: 46px;
  height: 29px;
  margin-right: 14px;
  background-color: rgba(204, 204, 220, 0.16) !important;
  padding-left: 10px;
  font-size: 14px !important;
  font-weight: normal !important;
  border-radius: 2px !important;
  border: none !important;
  color: #aaaaaa !important;
}

.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(3) > i {
  border-left-color: rgb(170, 170, 170); /* Color the Arrow */
}

.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(3):hover {
  background-color: rgba(204, 204, 220, 0.36) !important;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./projects/Forecasting/Tabs/Holidays/View/quarter-view-calendar.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sDAAsD;EACtD,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC,EAAE,oBAAoB;AAC9D;;AAEA;EACE,sDAAsD;EACtD,eAAe;AACjB;;AAEA,sCAAsC;;AAEtC;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sDAAsD;EACtD,kBAAkB;EAClB,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC,EAAE,oBAAoB;AAC7D;;AAEA;EACE,sDAAsD;EACtD,eAAe;AACjB","sourcesContent":[".rdrCalendarWrapper {\n  background: rgba(0, 0, 0, 0.02);\n}\n.rdrMonthAndYearPickers {\n  display: none;\n}\n.rdrMonthName {\n  text-align: center;\n  font-size: 14px;\n}\n\n.rdrDay {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.rdrDayNumber span {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.rdrDayToday > span {\n  background-color: #c65210;\n  border-radius: 10px;\n  padding: 2px;\n  width: 18px;\n  height: 18px;\n  margin: auto;\n}\n\n.rdrDayToday .rdrDayNumber span:after {\n  display: none;\n}\n\n.rdrCalendarWrapper {\n  height: 100%;\n}\n\n.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(1):before {\n  display: none !important;\n}\n\n.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(1) {\n  width: 46px;\n  height: 29px;\n  margin-left: 12px;\n  background-color: rgba(204, 204, 220, 0.16) !important;\n  font-size: 14px !important;\n  font-weight: normal !important;\n  border-radius: 2px !important;\n  border: none !important;\n  color: #aaaaaa !important;\n}\n\n.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(1) > i {\n  border-right-color: rgb(170, 170, 170); /* Color the Arrow */\n}\n\n.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(1):hover {\n  background-color: rgba(204, 204, 220, 0.36) !important;\n  cursor: pointer;\n}\n\n/* the second child is a hidden span */\n\n.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(3):before {\n  display: none !important;\n}\n\n.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(3) {\n  width: 46px;\n  height: 29px;\n  margin-right: 14px;\n  background-color: rgba(204, 204, 220, 0.16) !important;\n  padding-left: 10px;\n  font-size: 14px !important;\n  font-weight: normal !important;\n  border-radius: 2px !important;\n  border: none !important;\n  color: #aaaaaa !important;\n}\n\n.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(3) > i {\n  border-left-color: rgb(170, 170, 170); /* Color the Arrow */\n}\n\n.rdrCalendarWrapper > div:nth-child(1) > button:nth-child(3):hover {\n  background-color: rgba(204, 204, 220, 0.36) !important;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
